import styled from 'styled-components';
import { colors } from '../../core/Styles';

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Programs = styled.div`
  margin-top: 14px;
  & > :not(:last-child) {
    margin-bottom: 20.5px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 24px 0 10px 0;
  margin-top: 22px;
  border-top: 2px solid ${colors.faintGrey};
`;

export const PaginationButton = styled.button<{ disabled?: boolean }>`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  background-color: ${props => (props.disabled ? colors.faintGrey : '#ffffff')};
  border: 1px solid ${props => (props.disabled ? colors.faintGrey : colors.faintGrey)};
  transition: all 0.2s ease;
  &:hover:not(:disabled) {
    background-color: ${colors.primary};
    border-color: ${colors.primary};
    color: #ffffff;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }
  &:disabled {
    opacity: 0.6;
  }
`;

export const PageInfo = styled.div`
  min-width: 110px;
  display: flex;
  justify-content: center;
`;

export const RightContent = styled.div`
  display: flex;
  position: relative;
  border-left: 1px solid ${colors.faintGrey};
  padding-left: 15px;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > :not(:last-child) {
    margin-right: 8px;
  }
`;

export const Studiers = styled.div``;

export const Number = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 37px;
  color: ${colors.primary};
`;
